import { Button, Modal, InlineNotification, TextBox, IconChevronUp, IconChevronDown } from "@veneer/core";
import React, { useState, useEffect } from "react";
import ConnectAPI from "../../../services/api";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import moment from "moment";

const ModifyDateVA = (props) => {
    //Variables
    const [endDate, setEndDate] = useState('');
    const [endDateMonth, setEndDateMonth] = useState('');
    const [endDateYear, setEndDateYear] = useState('');
    const connectApi = new ConnectAPI();
    const { t, i18n } = useTranslation();
    const [showNotification, setShowNotification] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
    const [showButton, setShowButton] = useState(false);
    const [reloadButton, setReloadButton] = useState(false);

    //Metodos
    useEffect(() => {
        if( (props.endDate !== null & props.endDate.length !== 0) & (endDate === '' | endDate.length === 0) ){
            setEndDate( moment(new Date( new Date(props.endDate).getFullYear(), new Date(props.endDate).getMonth()+1, 0 )).format("YYYY-MM-DD") );
            setEndDateMonth(moment(props.endDate).format("MMM"));
            setEndDateYear(moment(props.endDate).format("YYYY"));
        }
    });
    function uploadAllDataButton(){
        let data = new FormData();
            data.append("Action","UpdateEndDate");
            data.append("idEndUser", props.item.idEndUser);
            data.append("StartDate",  moment(props.item.startDate).format("YYYY-MM-DD"));
            data.append("EndDate", endDate);
        const handleUploadResponse = (status, response) => {
            if (response === 'allGood') {
                setNotificationDetails({
                    title: t('notifyAllCorrect'),
                    type: 'positive',
                    description: ''
                });
                setReloadButton(true);
            } else {
                setNotificationDetails({
                    title: t("notifyWrognSQL"),
                    type: 'negative',
                    description: t("notifySQLError")
                });
            }
            setShowNotification(true);
        }
        connectApi.post(
            "api/Channels/uploadVAData",
            data,
            handleUploadResponse
        ).catch((error) => {
            props.setShowModal(false);
            Swal.fire(
                "Error " + error.response.status,
                error.response.data, "error"
            );
        });
    }
    const modifyDate = (operation, number) => {
        if (operation==='add') {
            setEndDate( moment(endDate).add(number, 'M').format("YYYY-MM-DD") )
            setEndDateMonth(moment(endDate).add(number, 'M').format("MMM"));
            setEndDateYear(moment(endDate).add(number, 'M').format("YYYY"));
            if ( moment(endDate).add(number, 'M').format("MMM/YYYY") === props.endDate )
                setShowButton(false);
            else
                setShowButton(true);
        } else if (operation==='sub') {
            if( new Date(moment(endDate).subtract(number, 'M')) >= new Date(props.dateLastP) ) {
                setEndDate( moment(endDate).subtract(number, 'M').format("YYYY-MM-DD") );
                setEndDateMonth(moment(endDate).subtract(number, 'M').format("MMM"));
                setEndDateYear(moment(endDate).subtract(number, 'M').format("YYYY"));
                if ( moment(endDate).subtract(number, 'M').format("MMM/YYYY") === props.endDate )
                    setShowButton(false);
                else
                    setShowButton(true);
            } else {
                setNotificationDetails({
                    title: t("notifyWrongDate"),
                    type: 'warning',
                    description: t("notifyDatesValue") + ": " + moment(props.dateLastP).format("MMM/YYYY")
                });
                setShowNotification(true);
            }
        }
    }
    const closeOption = () => {
        props.setShowModal(false); 
        setEndDate('');
        setShowButton(false);
    }

    //vista
    return (
        <Modal
            id="form-modal"
            onClose={reloadButton?(() =>{ props.setShowModal(false);window.location.reload(false)}):(() => closeOption())}
            closeButton={true}
            show={props.showModal}
            title={ "Volume Acceleration" }
            footer={(
                <div className="vn-button-group--responsive">
                    <Button onClick={uploadAllDataButton} disabled={!showButton} >{t('upload')}</Button>
                    { reloadButton ? (
                        <Button appearance="secondary" onClick={() => {window.location.reload(false)}}> Close </Button>
                    ) : (
                        <Button appearance="secondary" onClick={() => closeOption()}> Close </Button>
                    ) }
                    
                </div>
            )}
        >
            <label>{t('channel')}</label>
            <TextBox
                type='text'
                value={props.item.channel}
                readOnly
            /> <br />
            <label>{t('endUserName')}</label>
            <TextBox
                type='text'
                value={props.item.endUser}
                readOnly
            /> <br />
            <label>{t("endUserId")}</label>
            <TextBox
                type='text'
                value={props.item.idEndUser}
                readOnly
            /> <br />
            <label>{t("targetTPI")}</label>
            <TextBox
                type='text'
                value={props.item.targetTPI}
                readOnly
            /> <br />
            <label>{t("addBonus")}</label>
            <TextBox
                type='text'
                value={props.item.addBonus}
                readOnly
            /> <br />
            <label>{t("addCreditNote")}</label>
            <TextBox
                type='text'
                value={props.item.addCreditNote}
                readOnly
            /> <br />
            <label>{t("specialcondition.startdate")}</label>
            <TextBox
                type='text'
                value={props.item.startDate}
                readOnly
            /> <br />
            <div>
                <label>{t("specialcondition.enddate")}</label>
                <div className="buttonSmallVA">
                    <label>{endDateMonth}</label>
                    <Button leadingIcon={<IconChevronUp size={36} filled  />} onClick={()=>{ modifyDate('add', 1); }} />
                    <Button style={{marginTop: "18px"}} leadingIcon={<IconChevronDown size={22} filled  />} onClick={()=>{ modifyDate('sub', 1); }} />
                </div>
                <div className="buttonSmallVALeft">
                    <label>{endDateYear}</label>
                    <Button leadingIcon={<IconChevronUp size={36} filled />} onClick={()=>{ modifyDate('add', 12); }} />
                    <Button style={{marginTop: "18px"}} leadingIcon={<IconChevronDown size={22} filled />} onClick={()=>{ modifyDate('sub', 12); }} />
                </div>
                
            </div>
            {showNotification ? (
                <div className="show-animated" style={{ marginTop: '28px', marginBottom: '-16px' }}>
                    <InlineNotification
                        title={notificationDetails.title}
                        type={notificationDetails.type}
                        description={notificationDetails.description}
                        onClose={() => { setShowNotification(false) }}
                    />
                </div>
            ) : undefined}

        </Modal>
    );
}

export default ModifyDateVA;
